/**
 * Domain types for CyberVault School.
 *
 * These are the single source of truth for shapes shared between the API and the
 * web app. The Prisma schema (db/prisma/schema.prisma) mirrors these; keep them
 * in sync. Dates are carried as ISO-8601 strings over the wire.
 */
/** Core artifacts every class should have — these drive the completeness metric. */
export const MATERIAL_TYPES = ['recording', 'slides', 'transcript', 'summary'];
/** Optional extra study materials — not counted towards class completeness. */
export const SUPPLEMENT_TYPES = ['notes', 'infographic', 'incident'];
/** Every editable material slot (core artifacts + optional study materials). */
export const MATERIAL_SLOTS = [...MATERIAL_TYPES, ...SUPPLEMENT_TYPES];
/** Canonical display titles for the material slots. */
export const MATERIAL_TITLES = {
    recording: 'Class recording',
    slides: 'Slides',
    transcript: 'Transcript',
    summary: 'Summary',
    notes: 'Study notes',
    infographic: 'Infographic',
    incident: 'Incident report',
};
/** Suggested evidence tags (students can also type their own). */
export const EVIDENCE_TAGS = ['Screenshot', 'Config / Export', 'Script / Query', 'Document', 'Other'];
//# sourceMappingURL=types.js.map